<template>
	
	<div>
		<div class="banner">和优秀的人，做有挑战的事</div>
		
		<div class="news-detail">
			
		  <div class="news-header">
		    
		    <button @click="goBack" class="back-button">返回新闻列表</button>
		  </div>
		  
		  <div>
			  
			  <h1 style="text-align: center;">{{ news.title }}</h1>
		  </div>
		  
		  <div class="news-meta" style="margin-top: 30px;margin-bottom: 20px;">
		    <span>发布时间：{{ formatDate(news.date) }}</span>
		  </div>
		  
		  <div class="news-content">
			  
		    <div class="news-image">
		      <img :src="news.image" :alt="news.title" />
		    </div>
			
		    <div class="news-body multi-line-text">
		      <p>{{ news.content }}</p>
		    </div>
			
		  </div>
		</div>

	</div>

</template>

<script>
export default {
  name: 'NewsDetail',
  data() {
    return {
      news: null,
    };
  },
  created() {
    const newsId = this.$route.params.id;
    this.fetchNews(newsId);
  },
  methods: {
    fetchNews(id) {
      // 模拟数据，实际应用中应从API获取
      const newsItems = [

      ];
      this.news = newsItems.find(news => news.id === parseInt(id, 10));
    },
    goBack() {
      this.$router.push('/news');
    },
    formatDate(date) {
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      return new Date(date).toLocaleDateString('zh-CN', options);
    }
  }
};
</script>



<template>
  <div>
    <div class="banner">和优秀的人，做有挑战的事</div>

    <div class="news-detail" v-if="news">
      <div class="news-header">
        <button @click="goBack" class="back-button">返回新闻列表</button>
      </div>

      <h1 style="text-align: center;">{{ news.title }}</h1>

      <div class="news-meta" style="margin-top: 30px; margin-bottom: 20px;">
        <span>发布时间：{{ formatDate(news.date) }}</span>
      </div>

      <div class="news-content">
        <!-- 新闻图片 -->
        <div class="news-image">
          <img
            :src="getFullImageUrl(news.image)"
            :alt="news.title"
          />
        </div>

        <!-- 新闻正文 -->
        <div class="news-body multi-line-text">
          <p>{{ news.content }}</p>
        </div>
      </div>
    </div>

    <!-- 加载中 -->
    <div v-else-if="loading" class="loading">
      加载中...
    </div>

    <!-- 加载失败 -->
    <div v-else class="error">
      无法加载新闻详情，请稍后重试。
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'NewsDetail',
  data() {
    return {
      news: null,
      loading: true, // 控制加载状态
    };
  },
  created() {
    const newsId = this.$route.params.id;
    this.fetchNewsById(newsId);
  },
  methods: {
    // ✅ 新增：通过 ID 获取新闻详情
    async fetchNewsById(id) {
      this.loading = true;
      try {
        const response = await axios.post(this.$serverUrl + 'api/getNewsById/', {
          id: id
        });

        if (response.data.status === 200) {
          this.news = response.data.data; // 假设后端返回 { status: 200, data: { id, title, content, image, date, ... } }
        } else {
          this.$message.error(response.data.msg || '获取新闻失败');
        }
      } catch (error) {
        console.error('获取新闻详情失败:', error);
        this.$message.error('网络错误，无法加载新闻内容');
      } finally {
        this.loading = false;
      }
    },

    // 返回新闻列表
    goBack() {
      this.$router.push('/news');
    },

    // 格式化日期
    formatDate(date) {
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      return new Date(date).toLocaleDateString('zh-CN', options);
    },

    // 拼接完整图片 URL
    getFullImageUrl(imagePath) {
      return this.$serverUrl + imagePath;
    }
  }
};
</script>

<style scoped>
	
.banner {
  height: 150px;
  line-height: 150px;
  color: #fff;
  width: 100%;
  min-width: @main-width;
  background-image: url("../../assets/images/news.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  text-align: center;
  font-size: @font-size-larger;
}	

.news-detail {
  padding: 20px;
  background-color: #f9f9f9;
  width: 70%;
  margin: auto;
  margin-top:10px;
}

.news-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.news-meta {
  margin-bottom: 20px;
  color: #666;
}

.back-button {
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-left: 90%;
}

.back-button:hover {
  background-color: #0056b3;
}

.news-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.news-image {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
}

.news-image img {
  width: 100%;
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.news-body {
  text-align: justify;
  line-height: 1.6;
  font-size: 20px;
  color: #333;
}

.news-body p {
  margin: 10px 0;
}

@media (max-width: 768px) {
  .news-content {
    text-align: center;
  }

  .news-body {
    text-align: left;
  }
}

.multi-line-text {
  white-space: pre-wrap; /* 保留换行符和空白 */
  padding-left: 20px;
  padding-right: 20px;
  
}
</style>
